export default "__VITE_ASSET__D4YuB52f__"